module.exports = __webpack_public_path__ + "static/media/pic_404.3ed20fec.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/pic_404.png
// module id = 875
// module chunks = 0